import React from 'react';
import {
  Button,
  HStack,
  Icon,
  Center,
  useBoolean,
  useBreakpointValue,
  Tooltip,
} from '@wegroup/design-system';
import useToggleCompanyOverview from '../../hooks/useToggleCompanyOverview';
import { useTranslation } from 'react-i18next';
import CompanyScanBottomBarInfo from './CompanyScanBottomBarInfo';
import CompanyScanBottomBarWrapper from './CompanyScanBottomBarWrapper';
import BottomBarNextButton from './BottomBarNextButton';
import BottomBarPreviousButton from './BottomBarPreviousButton';

const CompanyScanBottomBar: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { t } = useTranslation();
  // Flows API
  const { showOverview } = useToggleCompanyOverview();

  // States
  const [isHovered, setIsHoverd] = useBoolean();
  const showButtonText = useBreakpointValue({ base: false, mobileL: true });

  return (
    <CompanyScanBottomBarWrapper
      transition="0.2s"
      p="0"
      px="4"
      isHovered={isHovered}
    >
      <BottomBarPreviousButton />
      <Center
        display={{ base: 'none', laptop: 'flex' }}
        onClick={showOverview}
        cursor="pointer"
        h="100%"
        onMouseEnter={setIsHoverd.on}
        onMouseLeave={setIsHoverd.off}
      >
        <CompanyScanBottomBarInfo />
      </Center>
      <HStack spacing="4" justifyContent="flex-end">
        <Tooltip
          label={t('COMPANY-SCAN_TOOLBAR_OVERIEW-BUTTON_DISABLED-TOOLTIP')}
          shouldWrapChildren
        >
          <Button
            variant="white"
            borderRadius="full"
            onClick={showOverview}
            data-test-id="COMPANY-SCAN_TOOLBAR_OVERIEW-BUTTON"
            leftIcon={<Icon boxSize="5" name="GeneralNavigationProducts" />}
          >
            {showButtonText && t('COMPANY-SCAN_TOOLBAR_OVERIEW-BUTTON')}
          </Button>
        </Tooltip>
        <BottomBarNextButton />
      </HStack>
    </CompanyScanBottomBarWrapper>
  );
};

export default CompanyScanBottomBar;
